import gql from 'graphql-tag';
import { PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT } from './PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT';


// Need to get back all the same fields as when requesting the planogram
// in the first place, otherwise will sometimes fail due to not having
// matching fields in the cache. Should use fragments to ensure this.

const FORCE_QUEUED_PRODUCT_CHANGE = gql`
	mutation forceProductChange ($id: ID!) {
		forceProductChange(id: $id) {
			...planogramItemPlanogramDetail
		}
	}
	${PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT}
`;

export default FORCE_QUEUED_PRODUCT_CHANGE;

